import { SsoApi } from '@/services/apis/sso-api';
import { httpClient } from '@/services/instance/api/httpClient';
import { csrfTokenService } from '@/services/instance/csrfTokenService';
import { optionsService } from '@/services/instance/optionsService';

export const ssoApi = new SsoApi({
    httpClient,
    optionsService,
    csrfTokenService,
});
